import { sanitizeReturnPath } from '../routing';

const RETURN_PATH_KEY = 'nimbalyst.console.returnPath';

export function rememberReturnPath(path: string): void {
  const safePath = sanitizeReturnPath(path);
  if (safePath && safePath !== '/') sessionStorage.setItem(RETURN_PATH_KEY, safePath);
}

export function peekReturnPath(): string | null {
  return sanitizeReturnPath(sessionStorage.getItem(RETURN_PATH_KEY));
}

export function consumeReturnPath(): string | null {
  const value = peekReturnPath();
  sessionStorage.removeItem(RETURN_PATH_KEY);
  return value;
}

export function authenticatedLandingPath(invitationAccepted: boolean): string {
  const returnPath = consumeReturnPath();
  if (returnPath) return returnPath;
  return invitationAccepted ? '/?invitation=accepted' : '/';
}
